var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.031 20.941h8.063a1.72 1.72 0 0 0 1.603-1.032l2.676-5.974c.08-.194.122-.397.122-.617v-1.703c0-.931-.797-1.968-1.772-1.968h-5.587l.844-3.596.028-.264c0-.349-.15-.666-.39-.896L13.673 4 7.766 9.616a1.648 1.648 0 0 0-.516 1.196v8.47c0 .931.806 1.66 1.781 1.66ZM2 11.06h3v9.882H2V11.06Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.d6dc1fcc.svg";
export { ForwardRef as ReactComponent };